export default __webpack_public_path__ + "static/media/C-Furnished.68f9f9b8.png";